<template>
    <div v-loading="loading">
        <div 
            ref="list-box"
            :style="{ height: `calc(100vh - ${total > 100 ? '200' : '248'}px)` }" 
            v-if="listData.length">
            <div class="list-box" v-if="currentLayout === 'block'">
                <list-item 
                    v-for="item in listData"
                    :itemData="item" 
                    :class="{'slide': Number(planIdShow) === item.planId}"
                    :key="item.planId">
                </list-item>
                <div class="bef" v-show="remainder==2 || remainder==1"></div>
                <div class="bef" v-show="remainder==1"></div>
            </div>
            <div class="table-box" v-else>
                <c-table 
                    @operation="operation" 
                    :tableData="listData" 
                    :ISChangeCheckout="false" 
                    :tableHeader="planTableHeader" 
                    :TableHeight="`calc( 100vh - ${ total < 100 ? 240 : 280}px )`">
                </c-table>
            </div>
        </div>
        <null-list v-else></null-list>
        <paging 
            :total="total" 
            @currentChange="(pageNo)=>{this.pageNo = pageNo; getList('pageNo')}" 
            :pageNo="pageNo">
        </paging>
    </div>
    
</template>
<script>
import mins from '@/views/planHome/mins'
import mainMins from '@/mins/main'
import listItem from '@/views/planHome/list-item'
import fetch from '@/api/fetch'
import nullList from '@/components/nullList'
import CTable from '@/components/table'
import { Base64 } from 'js-base64'
import paging from '@/components/paging'
import {getQueryParams, queryStringToBase } from '@/utils/common'
import { getStore } from '@/utils/common'
import Vue from 'vue'
export default {
    name: 'listBox',
    components: {
        listItem,
        nullList,
        paging,
        CTable
    },
    data() {
        return {
            planTableHeader: [
                {prop: 'planName', label: this.$t('homePage.NAME')},
                {prop: 'beginTime', label: this.$t('testControl.KSSJ'), width: 175},
                {prop: 'endTime', label: this.$t('testControl.JSSJ'), width: 175},
                {prop: 'statusName', label: this.$t('personalPlanDetail.ZT'), width: 100},
                {prop: 'operation', label: this.$t('accoutNumberAdmin.CZ'),SlotType:{
                    buttons:[
                      {
                        name: this.$t('examListCom.ENTER'), // 进入练习
                        emitName: 'goPlan', // 事件Type 必传
                        isShow: ['status', 0, 2],
                      },
                      {
                        name: this.$t('planHome.JSLX'), // 结束练习
                        emitName: 'endPlan', // 事件Type 必传
                        isShow: ['status', 0, 2],
                      },
                      {
                        name: this.$t('teamFraction.CKCJ'), // 查看成绩
                        emitName: 'goAnswer', // 事件Type 必传
                        auth: [['teacher', 'student'], 'pro'],
                        isShow: ['status', 3, 2],
                      },
                      {
                        name: this.$t('planHome.SCJH'), // 删除计划
                        emitName: 'deletePlan', // 事件Type 必传
                        isShow: ['status', 1, 2],
                        auth: [['teacher'], []]
                      }
                    ]
                }}
            ]
        }
    },
    props:{
        currentLayout: {
            type: String,
            default: 'block'
        }
    },
    mixins: [mins,mainMins],
    watch:{
        $route(){
            this.getList()
        }
    },
    created(){
        this.getList()
    },
    methods:{
        operation(type, itemData){
            if(type === 'endPlan'){
                this.endPlan(itemData)
            }else if(type === 'goPlan'){
                this.goPlanLxDetail(itemData);
                this.setPlan()
            }else if(type === 'deletePlan'){
                this.deletePlanBtn(itemData)
            }else if(type === 'goAnswer'){
                this.goNext(itemData)
            }
        },
        goNext(itemData){
            let { patternLx } = JSON.parse(this.__Base64.decode(queryStringToBase(getQueryParams().q)))
            let q = this.__Base64.encode(JSON.stringify({
                pattern_lx: patternLx,
                planId: itemData.planId,
                playerId: itemData.playerId
            }))
            sessionStorage.setItem('showFractionUrl', JSON.stringify(this.$route.fullPath))
            if(patternLx == 0){
                this.$router.push(`/showFraction?q=${q}`)
            }else{
                this.$router.push(`/showFractionStudent?q=${q}`)
            }
            
        },
        deletePlanBtn(itemData) {
             this.$confirm(this.$t('planHome.SFSCDQJH'), this.$t('planHome.TS'), {
                confirmButtonText: this.$t('planHome.QD'),
                cancelButtonText: this.$t('planHome.QX'),
                type: 'warning'
            }).then(() => {
                fetch.hidePlan({
                    planId: itemData.planId
                }).then(res=>{
                    if(res.code == 0){
                        this.getList()
                        this.$notify({ title: this.$t('planHome.CZ'), message: this.$t('planHome.CZCG'), type: 'success' });
                    }else{
                        this.$notify({ title: this.$t('planHome.CZ'), message: res.msg || this.$t('planHome.SCJHSB'), type: 'error' });
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: this.$t('planHome.YQXSC')
                }); 
            })   
        },
        endPlan(itemData){
            this.$confirm(this.$t('planHome.SFJSDQJH'), this.$t('planHome.TS'), {
                confirmButtonText: this.$t('planHome.QD'),
                cancelButtonText: this.$t('planHome.QX'),
                type: 'warning'
            }).then(() => {
                fetch.planComplete({
                    planId: itemData.planId
                }).then(res=>{
                    if(res.code == 0){
                        this.getList()
                        this.$notify({ title: this.$t('planHome.CZ'), message: this.$t('planHome.CZCG'), type: 'success' });
                    }else{
                        this.$notify({ title: this.$t('planHome.CZ'), message: res.msg || this.$t('planHome.JSJHSB'), type: 'error' });
                    }
                })
            })   
        },
        setPlan(){
            Vue.prototype.__planData = this.itemData
        },
        getList(type){
            this.loading = true
            let statusNames = {
                0: this.$t('studentDetail.WKS'),
                1: this.$t('studentDetail.JXZ'),
                2: this.$t('planHome.YJS')
            }
            let { patternLx, pattern_lx } = JSON.parse(Base64.decode(queryStringToBase(getQueryParams().q)))
            // console.log(JSON.parse(Base64.decode(this.$route.query.q)))
            let { searchContent, planStatus } = this.$parent.$refs['planSeach']
            let { professionId, provinceId, subjectId } = JSON.parse(sessionStorage.getItem('queryData'))

            let { isSys } = JSON.parse(sessionStorage.getItem('queryData'))
            let { userType } = this.__userData
            let q = this.__Base64.encode(JSON.stringify({patternLx: 'adminSet', time: +new Date()}))
            if(isSys == 0 && userType == 0){
                this.$router.push({name: 'adminSet', query: { q }})
            }
            let pattern = patternLx !== undefined ? patternLx : pattern_lx
            if(type != 'pageNo' && planStatus || searchContent){
                this.pageNo = 1
            }
            fetch.planList({
                pageNo: this.pageNo,
                limitSize: 100,
                professionId,
                subjectId,
                provinceId,
                pattern: pattern == 2 ? 1 : pattern,
                isTeacher: pattern == 2 ? 1 : 0,
                searchContent,
                planStatus
            }).then(res=>{
                this.listData = []
                this.loading = false
                this.planIdShow = null
                if(res.code == 0 && res.data){
                    this.listData = res.data.records.map(item=>{
                        return {
                            ...item,
                            statusName: statusNames[item.status],
                            // disabled: item.status <= 1 ? 0 : 1
                         }
                    })
                    // for(let i = 0; i < 1; i++){
                    //     this.listData.push({
                    //         planId: i + 1
                    //     })
                    // }
                    this.remainder = this.listData.length % 3
                    this.total = res.total
                    this.$nextTick(()=>{
                        try{
                            let planId = getStore('planIdShow');
                            let listBox = this.$refs['list-box'];
                            const elem = document.querySelector(`#planItem${planId}`);
                            if(planId && elem && this.listData){
                                if(listBox.scrollHeight > listBox.clientHeight){
                                    elem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                }
                                this.planIdShow = planId
                            }
                        }catch(e){
                            console.log(e);
                        }
                        
                    })
                }else if(res.code != 0){
                    this.$notify({ title: this.$t('planHome.CZ'), message: res.msg || this.$t('planHome.HQSJSB'), type: 'error' });
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.list-box{
    /* padding: 12px; */
    box-sizing: border-box;
    flex: 1;
    height: calc(100vh - 248px);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;
    align-content: flex-start;
    overflow: auto;
    .bef{
        width: 27%;
        height: 200px;
        opacity: 1;
        border-radius: 5px;
        margin: 0 1.2% 64px 0;
        padding: 24px 0 0 24px;
        min-width: 340px;
    }
}
.table-box{
    height: 100%;
}
.slide{
    animation: slide-out 1.5s;
}
@keyframes slide-out {
    from {
        box-shadow: none;
    }
    to {
        box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.9);
    }
  }
</style>